import Button from "../base/Button.js";
import PlainButtonMixin from "./PlainButtonMixin.js";

/**
 * Button component in the Plain reference design system
 *
 * @inherits Button
 */
class PlainButton extends PlainButtonMixin(Button) {}

export default PlainButton;
